// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SVjr","productName":"Table_productName__2LLqI"};